import React, { useRef, useState } from "react";

import { AjustesQuiz, DatosQuiz, MostrarRespuestas, PreguntaQuiz, QuizCompleto, TipoPregunta } from "../../../../services/v2/lmsQuiz.service";
import { Icono, mensajeDeError, reducirImagen } from "../comun";
import { puntosTxt } from "../tareas/comunTareas";
import "../tareas/tareas.css";
import "./quiz.css";

/*
	Editor de preguntas del quiz (Portal de Clase, Parte D). El mismo en Nueva Tarea (forma de entrega Quiz) y en Catálogo › Cursos ›
	Contenido. Tipos: Opción Múltiple (una correcta), Casillas (varias), Verdadero O Falso, Respuesta Corta (respuestas aceptadas) y
	Párrafo (lo califica el maestro). Los puntos del quiz son la suma de sus preguntas. Cada pregunta y opción conserva su id al
	guardar (las respuestas de los alumnos cuelgan de él). El servidor vuelve a validar todo.
*/

export const TIPOS_PREGUNTA: [TipoPregunta, string][] = [["opcion", "Opción Múltiple"], ["casillas", "Casillas"], ["vf", "Verdadero O Falso"], ["corta", "Respuesta Corta"], ["parrafo", "Párrafo"]]
export const TIPO_PREGUNTA: Record<TipoPregunta, string> = { opcion: "Opción Múltiple", casillas: "Casillas", vf: "Verdadero O Falso", corta: "Respuesta Corta", parrafo: "Párrafo" }
export const MOSTRAR: [MostrarRespuestas, string, string][] = [
	["nunca", "Nunca", "Solo ven su nota"], ["entregar", "Al Entregar", "Al entregar su último intento"], ["vencer", "Al Vencer", "Cuando ya nadie puede contestar"], ["devolver", "Al Devolver", "Cuando les devuelves la nota"]]

interface OpcionForma { k: string; id?: string; text: string; correct: boolean }
export interface PreguntaForma
{
	k: string
	id?: number
	type: TipoPregunta
	text: string
	points: string
	explanation: string
	conExplicacion: boolean
	image: { key: string; name: string; vista: string | null } | null
	options: OpcionForma[]
	accepted: string[]
}
export interface AjustesForma { tiempo: string; intentos: number; barajar: boolean; ver: MostrarRespuestas }
export interface QuizForma { preguntas: PreguntaForma[]; ajustes: AjustesForma }
/** Los cambios llegan como función sobre el estado más nuevo: una imagen que termina de subir no pisa lo que se escribió mientras. */
export type CambioQuiz = QuizForma | ((f: QuizForma) => QuizForma)

let contador = 0
const llave = (): string => "q" + Date.now().toString(36) + (++contador)

const opcionesDe = (tipo: TipoPregunta): OpcionForma[] =>
	tipo === "vf" ? [{ k: llave(), id: "v", text: "Verdadero", correct: true }, { k: llave(), id: "f", text: "Falso", correct: false }]
		: tipo === "opcion" || tipo === "casillas" ? [{ k: llave(), text: "", correct: true }, { k: llave(), text: "", correct: false }] : []

export const preguntaNueva = (tipo: TipoPregunta): PreguntaForma =>
	({ k: llave(), type: tipo, text: "", points: tipo === "parrafo" ? "5" : "1", explanation: "", conExplicacion: false, image: null, options: opcionesDe(tipo), accepted: tipo === "corta" ? [""] : [] })

export const AJUSTES_BASE: AjustesQuiz = { timeLimitMin: null, maxAttempts: 1, shuffle: false, showAnswers: "vencer" }

export const formaDeQuiz = (q: QuizCompleto | null | undefined): QuizForma => {
	const a = q?.settings || AJUSTES_BASE
	return {
		ajustes: { tiempo: a.timeLimitMin ? String(a.timeLimitMin) : "", intentos: a.maxAttempts || 1, barajar: !!a.shuffle, ver: a.showAnswers || "vencer" },
		preguntas: (q?.questions || []).map((p) => ({
			k: llave(), id: p.id, type: p.type, text: p.text, points: puntosTxt(p.points), explanation: p.explanation || "", conExplicacion: !!p.explanation,
			image: p.image ? { key: p.image.key, name: p.image.name, vista: p.image.url || null } : null,
			options: p.type === "vf" ? [{ k: llave(), id: "v", text: "Verdadero", correct: p.options.some((o) => o.id === "v" && o.correct) }, { k: llave(), id: "f", text: "Falso", correct: p.options.some((o) => o.id === "f" && o.correct) }]
				: p.options.map((o) => ({ k: llave(), id: o.id, text: o.text, correct: !!o.correct })),
			accepted: p.type === "corta" ? (p.accepted.length > 0 ? [...p.accepted] : [""]) : [],
		})),
	}
}

export const totalDeForma = (f: QuizForma): number => Math.round(f.preguntas.reduce((s, p) => s + (Number(p.points.replace(",", ".")) || 0), 0) * 100) / 100

export const datosDeForma = (f: QuizForma): DatosQuiz => ({
	settings: { timeLimitMin: f.ajustes.tiempo.trim() === "" ? null : Number(f.ajustes.tiempo), maxAttempts: f.ajustes.intentos, shuffle: f.ajustes.barajar, showAnswers: f.ajustes.ver },
	questions: f.preguntas.map((p): PreguntaQuiz => ({
		...(p.id ? { id: p.id } : {}),
		type: p.type, text: p.text.trim(), points: Number(p.points.replace(",", ".")) || 0,
		explanation: p.conExplicacion && p.explanation.trim() ? p.explanation.trim() : null,
		image: p.image ? { key: p.image.key, name: p.image.name } : null,
		options: p.type === "corta" || p.type === "parrafo" ? [] : p.options.map((o) => ({ ...(o.id ? { id: o.id } : {}), text: o.text.trim(), correct: o.correct })),
		accepted: p.type === "corta" ? p.accepted.map((x) => x.trim()).filter(Boolean) : [],
	})),
})

/** Lo mismo que revisa el servidor, para avisar antes de mandar. null = todo bien. */
export const revisarForma = (f: QuizForma): string | null => {
	const t = f.ajustes.tiempo.trim()
	if (t !== "" && (!/^\d+$/.test(t) || Number(t) < 1 || Number(t) > 600)) return "El tiempo límite va de 1 a 600 minutos (vacío = sin tiempo)."
	for (let i = 0; i < f.preguntas.length; i++) {
		const p = f.preguntas[i]
		const n = "Pregunta " + (i + 1) + ": "
		if (p.text.trim() === "") return n + "escribe la pregunta."
		const pts = Number(p.points.replace(",", "."))
		if (!(pts > 0) || pts > 1000) return n + "los puntos van de 0.01 a 1000."
		if (p.type === "opcion" || p.type === "casillas") {
			if (p.options.length < 2) return n + "necesita al menos 2 opciones."
			if (p.options.some((o) => o.text.trim() === "")) return n + "a una opción le falta texto."
			const c = p.options.filter((o) => o.correct).length
			if (p.type === "opcion" && c !== 1) return n + "marca la respuesta correcta."
			if (p.type === "casillas" && c < 1) return n + "marca al menos una respuesta correcta."
		}
		if (p.type === "corta" && p.accepted.every((x) => x.trim() === "")) return n + "escribe al menos una respuesta aceptada."
	}
	return null
}

// ---------------------------------------------------------------- una pregunta

const cambiarTipo = (p: PreguntaForma, tipo: TipoPregunta): PreguntaForma => {
	if (tipo === p.type) return p
	let options = p.options
	if (tipo === "vf") options = opcionesDe("vf")
	else if (tipo === "opcion" || tipo === "casillas") {
		options = p.type === "opcion" || p.type === "casillas" ? p.options : opcionesDe(tipo)
		if (tipo === "opcion") { let ya = false; options = options.map((o) => { const c = o.correct && !ya; if (c) ya = true; return { ...o, correct: c } }); if (!ya && options[0]) options = options.map((o, i) => ({ ...o, correct: i === 0 })) }
	} else options = []
	return { ...p, type: tipo, options, accepted: tipo === "corta" ? (p.accepted.length ? p.accepted : [""]) : [] }
}

interface PropsPregunta
{
	p: PreguntaForma
	n: number
	total: number
	soloLectura: boolean
	subirImagen?: (f: File) => Promise<string>
	onSubiendo?: (subiendo: boolean) => void
	onCambio: (fn: (p: PreguntaForma) => PreguntaForma) => void
	onMover: (delta: number) => void
	onDuplicar: () => void
	onBorrar: () => void
}

const TarjetaPregunta: React.FC<PropsPregunta> = ({ p, n, total, soloLectura, subirImagen, onSubiendo, onCambio, onMover, onDuplicar, onBorrar }) => {
	const entrada = useRef<HTMLInputElement>(null)
	const [subiendo, setSubiendo] = useState<boolean>(false)
	const [error, setError] = useState<string | null>(null)
	const poner = (c: Partial<PreguntaForma>) => onCambio((x) => ({ ...x, ...c }))
	const ponerOpcion = (i: number, c: Partial<OpcionForma>) => onCambio((x) => ({ ...x, options: x.options.map((o, j) => (j === i ? { ...o, ...c } : o)) }))
	const marcar = (i: number) => {
		if (soloLectura) return
		if (p.type === "casillas") onCambio((x) => ({ ...x, options: x.options.map((o, j) => (j === i ? { ...o, correct: !o.correct } : o)) }))
		else onCambio((x) => ({ ...x, options: x.options.map((o, j) => ({ ...o, correct: j === i })) }))
	}
	const imagen = async (f: File | undefined) => {
		if (!f || !subirImagen) return
		if (!/^image\//.test(f.type)) { setError("Solo imágenes (JPG, PNG o WebP)."); return }
		setError(null); setSubiendo(true); if (onSubiendo) onSubiendo(true)
		try {
			const r = await reducirImagen(f, 1600)
			const key = await subirImagen(r)
			onCambio((x) => ({ ...x, image: { key, name: r.name, vista: URL.createObjectURL(r) } }))
		} catch (e) { setError(mensajeDeError(e, "No se pudo subir la imagen.")) } finally { setSubiendo(false); if (onSubiendo) onSubiendo(false); if (entrada.current) entrada.current.value = "" }
	}
	const id = "qz" + p.k

	return (
		<section className="pcTarjeta qzPregunta" aria-label={"Pregunta " + n}>
			<div className="qzCabeza">
				<span className="qzNumero" aria-hidden="true">{n}</span>
				<label htmlFor={id + "t"} style={{ position: "absolute", left: -9999 }}>Tipo de la pregunta {n}</label>
				<select id={id + "t"} className="pcSelect qzTipo" value={p.type} disabled={soloLectura} onChange={(e) => { const t = e.target.value as TipoPregunta; onCambio((x) => cambiarTipo(x, t)) }}>
					{TIPOS_PREGUNTA.map(([t, texto]) => <option key={t} value={t}>{texto}</option>)}
				</select>
				<span className="qzPuntos">
					<label htmlFor={id + "p"} style={{ position: "absolute", left: -9999 }}>Puntos de la pregunta {n}</label>
					<input id={id + "p"} inputMode="decimal" value={p.points} disabled={soloLectura} onChange={(e) => poner({ points: e.target.value })} /><b>Pts</b>
				</span>
				{!soloLectura ? (
					<span className="qzAcciones">
						<button type="button" className="pcIb" aria-label={"Subir la pregunta " + n} disabled={n === 1} onClick={() => onMover(-1)}><Icono n="arriba" size={17} /></button>
						<button type="button" className="pcIb" aria-label={"Bajar la pregunta " + n} disabled={n === total} onClick={() => onMover(1)}><Icono n="abajo" size={17} /></button>
						<button type="button" className="pcIb" aria-label={"Duplicar la pregunta " + n} onClick={onDuplicar}><Icono n="copiar" size={17} /></button>
						<button type="button" className="pcIb" aria-label={"Borrar la pregunta " + n} onClick={onBorrar}><Icono n="basura" size={17} /></button>
					</span>
				) : null}
			</div>

			<label htmlFor={id + "x"} style={{ position: "absolute", left: -9999 }}>Texto de la pregunta {n}</label>
			<textarea id={id + "x"} className="pcTextarea qzTexto" rows={2} maxLength={2000} placeholder="Escribe La Pregunta" value={p.text} disabled={soloLectura} onChange={(e) => poner({ text: e.target.value })} />

			{p.image ? (
				<div className="qzImagen">
					{p.image.vista ? <img src={p.image.vista} alt={"Imagen de la pregunta " + n} /> : <span className="pcTenue pcChico">{p.image.name}</span>}
					{!soloLectura ? <button type="button" className="pcIb" aria-label={"Quitar la imagen de la pregunta " + n} onClick={() => poner({ image: null })}><Icono n="cerrar" size={18} /></button> : null}
				</div>
			) : null}

			{p.type === "opcion" || p.type === "casillas" ? (
				<div className="qzOpciones" role="group" aria-label={"Opciones de la pregunta " + n}>
					{p.options.map((o, i) => (
						<div className={"qzOpcion" + (o.correct ? " qzOpcionOk" : "")} key={o.k}>
							<button type="button" className={"qzMarca" + (p.type === "casillas" ? " qzMarcaCuadro" : "")} aria-pressed={o.correct} disabled={soloLectura}
								aria-label={"Opción " + (i + 1) + (o.correct ? ": correcta" : ": marcar como correcta")} onClick={() => marcar(i)}>{o.correct ? <Icono n="check" size={16} /> : null}</button>
							<label htmlFor={id + "o" + i} style={{ position: "absolute", left: -9999 }}>Texto de la opción {i + 1}</label>
							<input id={id + "o" + i} className="qzOpcionTexto" maxLength={500} placeholder={"Opción " + (i + 1)} value={o.text} disabled={soloLectura} onChange={(e) => ponerOpcion(i, { text: e.target.value })} />
							{!soloLectura && p.options.length > 2 ? <button type="button" className="pcIb" style={{ width: 40, height: 40 }} aria-label={"Quitar la opción " + (i + 1)} onClick={() => onCambio((x) => ({ ...x, options: x.options.filter((_, j) => j !== i) }))}><Icono n="cerrar" size={16} /></button> : null}
						</div>
					))}
					{!soloLectura && p.options.length < 10 ? <button type="button" className="pcEnlaceBtn" onClick={() => onCambio((x) => ({ ...x, options: [...x.options, { k: llave(), text: "", correct: false }] }))}>Agregar Opción</button> : null}
					<div className="pcTenue pcChico">{p.type === "opcion" ? "Toca el círculo de la respuesta correcta." : "Marca todas las correctas. Vale por partes: aciertos menos errores, nunca menos de 0."}</div>
				</div>
			) : null}

			{p.type === "vf" ? (
				<div className="qzVf" role="group" aria-label="Respuesta correcta">
					{p.options.map((o, i) => <button key={o.k} type="button" className="tkSegmento" aria-pressed={o.correct} disabled={soloLectura} onClick={() => marcar(i)}>{o.text}<small>{o.correct ? "Correcta" : " "}</small></button>)}
				</div>
			) : null}

			{p.type === "corta" ? (
				<div className="qzOpciones" role="group" aria-label={"Respuestas aceptadas de la pregunta " + n}>
					<span className="pcCampoEtiqueta">Respuestas Aceptadas</span>
					{p.accepted.map((x, i) => (
						<div className="qzOpcion" key={i}>
							<label htmlFor={id + "a" + i} style={{ position: "absolute", left: -9999 }}>Respuesta aceptada {i + 1}</label>
							<input id={id + "a" + i} className="qzOpcionTexto" maxLength={300} placeholder={i === 0 ? "Por Ejemplo: Levadura" : "Otra Forma De Escribirla"} value={x} disabled={soloLectura} onChange={(e) => { const v = e.target.value; onCambio((x) => ({ ...x, accepted: x.accepted.map((y, j) => (j === i ? v : y)) })) }} />
							{!soloLectura && p.accepted.length > 1 ? <button type="button" className="pcIb" style={{ width: 40, height: 40 }} aria-label={"Quitar la respuesta " + (i + 1)} onClick={() => onCambio((x) => ({ ...x, accepted: x.accepted.filter((_, j) => j !== i) }))}><Icono n="cerrar" size={16} /></button> : null}
						</div>
					))}
					{!soloLectura && p.accepted.length < 10 ? <button type="button" className="pcEnlaceBtn" onClick={() => onCambio((x) => ({ ...x, accepted: [...x.accepted, ""] }))}>Agregar Otra Respuesta</button> : null}
					<div className="pcTenue pcChico">No importan mayúsculas, acentos ni espacios de sobra.</div>
				</div>
			) : null}

			{p.type === "parrafo" ? <div className="pcNota">El alumno escribe su respuesta y tú la calificas en Resultados.</div> : null}

			{p.conExplicacion ? (
				<div className="pcCampo">
					<label className="pcCampoEtiqueta" htmlFor={id + "e"}>Explicación (La Ven Con Las Respuestas)</label>
					<textarea id={id + "e"} className="pcTextarea" rows={2} maxLength={2000} value={p.explanation} disabled={soloLectura} onChange={(e) => poner({ explanation: e.target.value })} />
				</div>
			) : null}

			{!soloLectura ? (
				<div className="qzPie">
					<input ref={entrada} type="file" accept="image/*" hidden onChange={(e) => imagen(e.target.files?.[0])} />
					{subirImagen && !p.image ? <button type="button" className="pcBtn pcBtnS pcBtnChico" disabled={subiendo} onClick={() => entrada.current?.click()}><Icono n="foto" size={16} />{subiendo ? "Subiendo…" : "Agregar Imagen"}</button> : null}
					{!p.conExplicacion ? <button type="button" className="pcBtn pcBtnS pcBtnChico" onClick={() => poner({ conExplicacion: true })}><Icono n="pregunta" size={16} />Agregar Explicación</button>
						: <button type="button" className="pcBtn pcBtnS pcBtnChico" onClick={() => poner({ conExplicacion: false, explanation: "" })}>Quitar Explicación</button>}
				</div>
			) : null}
			{error ? <div className="pcAviso pcOro" role="alert">{error}</div> : null}
		</section>
	)
}

// ---------------------------------------------------------------- lista de preguntas

interface PropsPreguntas
{
	forma: QuizForma
	onCambio: (c: CambioQuiz) => void
	soloLectura?: boolean
	subirImagen?: (f: File) => Promise<string>
	/** Avisa cuando empieza (true) o termina (false) de subir una imagen, para no guardar a medias. */
	onSubiendo?: (subiendo: boolean) => void
}

export const PreguntasQuiz: React.FC<PropsPreguntas> = ({ forma, onCambio, soloLectura = false, subirImagen, onSubiendo }) => {
	const ps = forma.preguntas
	const cambiar = (fn: (l: PreguntaForma[]) => PreguntaForma[]) => onCambio((f) => ({ ...f, preguntas: fn(f.preguntas) }))
	const agregar = (tipo: TipoPregunta) => cambiar((l) => [...l, preguntaNueva(tipo)])
	const mover = (k: string, d: number) => cambiar((l) => {
		const i = l.findIndex((x) => x.k === k)
		const j = i + d
		if (i < 0 || j < 0 || j >= l.length) return l
		const c = [...l]; const x = c[i]; c[i] = c[j]; c[j] = x; return c
	})
	const duplicar = (k: string) => cambiar((l) => {
		const i = l.findIndex((x) => x.k === k)
		if (i < 0) return l
		const o = l[i]
		const copia: PreguntaForma = { ...o, k: llave(), id: undefined, options: o.options.map((x) => ({ ...x, k: llave(), id: o.type === "vf" ? x.id : undefined })), accepted: [...o.accepted] }
		return [...l.slice(0, i + 1), copia, ...l.slice(i + 1)]
	})
	const borrar = (i: number) => {
		const p = ps[i]
		if ((p.text.trim() !== "" || p.id) && !window.confirm("¿Borrar la pregunta " + (i + 1) + "?" + (p.id ? " Las respuestas que ya tenga dejan de contar." : ""))) return
		cambiar((l) => l.filter((x) => x.k !== p.k))
	}
	return (
		<div className="qzLista">
			<div className="qzTotal">
				<span className="pcCampoEtiqueta" style={{ flex: 1 }}>Preguntas · {ps.length}</span>
				<span className="pcTenue">Total <b style={{ color: "var(--pc-tinta)" }}>{puntosTxt(totalDeForma(forma))} Pts</b></span>
			</div>
			{ps.length === 0 ? <div className="pcTarjeta pcTenue" style={{ padding: 18 }}>{soloLectura ? "Este quiz aún no tiene preguntas." : "Aún no hay preguntas. Agrega la primera: los puntos del quiz son la suma de sus preguntas."}</div> : null}
			{ps.map((p, i) => (
				<TarjetaPregunta key={p.k} p={p} n={i + 1} total={ps.length} soloLectura={soloLectura} subirImagen={subirImagen} onSubiendo={onSubiendo}
					onCambio={(fn) => cambiar((l) => l.map((y) => (y.k === p.k ? fn(y) : y)))} onMover={(d) => mover(p.k, d)} onDuplicar={() => duplicar(p.k)} onBorrar={() => borrar(i)} />
			))}
			{!soloLectura && ps.length < 100 ? (
				<div className="pcTarjeta qzAgregar">
					<span className="pcCampoEtiqueta">Agregar Pregunta</span>
					<div className="qzAgregarBotones">
						{TIPOS_PREGUNTA.map(([t, texto]) => <button key={t} type="button" className="pcBtn pcBtnS pcBtnChico" onClick={() => agregar(t)}><Icono n="mas" size={15} />{texto}</button>)}
					</div>
				</div>
			) : null}
		</div>
	)
}

// ---------------------------------------------------------------- ajustes

export const AjustesDelQuiz: React.FC<{ forma: QuizForma; onCambio: (c: CambioQuiz) => void; soloLectura?: boolean }> = ({ forma, onCambio, soloLectura = false }) => {
	const a = forma.ajustes
	const poner = (c: Partial<AjustesForma>) => onCambio((f) => ({ ...f, ajustes: { ...f.ajustes, ...c } }))
	return (
		<div className="pcTarjeta" style={{ padding: 20, gap: 14 }}>
			<span className="pcCampoEtiqueta">Ajustes Del Quiz</span>
			<div className="tkFilaCampos">
				<div className="pcCampo"><label className="pcCampoEtiqueta" htmlFor="qzTiempo">Tiempo (Min)</label>
					<input id="qzTiempo" className="pcInput" inputMode="numeric" placeholder="Sin Límite" value={a.tiempo} disabled={soloLectura} onChange={(e) => poner({ tiempo: e.target.value.replace(/\D/g, "").slice(0, 3) })} /></div>
				<div className="pcCampo"><label className="pcCampoEtiqueta" htmlFor="qzIntentos">Intentos</label>
					<select id="qzIntentos" className="pcSelect" value={a.intentos} disabled={soloLectura} onChange={(e) => poner({ intentos: Number(e.target.value) })}>
						{[1, 2, 3, 4, 5].map((n) => <option key={n} value={n}>{n === 1 ? "1 Intento" : n + " Intentos"}</option>)}
					</select></div>
			</div>
			{a.intentos > 1 ? <div className="pcTenue pcChico">Cuenta el mejor intento.</div> : null}
			<div className="pcInterruptorFila" style={{ padding: 0 }}>
				<span>Barajar Preguntas Y Opciones</span>
				<button type="button" role="switch" aria-checked={a.barajar} aria-label="Barajar preguntas y opciones" disabled={soloLectura} className={"pcSw" + (a.barajar ? " pcSwOn" : "")} onClick={() => poner({ barajar: !a.barajar })} />
			</div>
			<div className="pcCampo">
				<span className="pcCampoEtiqueta">Ven Las Respuestas Correctas</span>
				<div className="qzMostrar" role="radiogroup" aria-label="Cuándo ven las respuestas correctas">
					{MOSTRAR.map(([id, texto, sub]) => (
						<button key={id} type="button" role="radio" aria-checked={a.ver === id} className="tkSegmento" aria-pressed={a.ver === id} disabled={soloLectura} onClick={() => poner({ ver: id })}>{texto}<small>{sub}</small></button>
					))}
				</div>
			</div>
		</div>
	)
}
